import { Label, List } from '@mairistem/composants';
import _ from 'lodash';

const PosteComptableContactListItem = (props) => {
  const { telephone, mail } = props;

  return (
    <>
      <List.Description>
        <Label content={_.isEmpty(telephone) ? '-' : telephone} icon="phone" />
      </List.Description>
      <List.Description>
        <Label content={_.isEmpty(mail) ? '-' : mail} icon="mail" />
      </List.Description>
    </>
  );
};

export default PosteComptableContactListItem;
